import React from 'react'

import { ReactComponent as ArrowIcon } from '../../svgs/arrow.svg'

import styles from './styles.module.css'

export interface CardHeaderExpandProps {
  expandable?: boolean
  expanded?: boolean
}

interface CardHeaderProps extends CardHeaderExpandProps {
  content: React.ReactNode
  'data-ocweb-id': string
}

export const CardHeader: React.FC<CardHeaderProps> = ({
  content,
  expandable,
  expanded,
  'data-ocweb-id': dataTestId
}) => {
  let expandableArrow: React.ReactElement | undefined

  if (expandable) {
    if (expanded) {
      expandableArrow = <ArrowIcon width="10" height="10" className={styles.expandedIcon} />
    } else {
      expandableArrow = <ArrowIcon width="10" height="10" className={styles.collapsedIcon} />
    }
  }

  return (
    <div
      className={styles.cardHeader}
      data-ocweb-id={`${dataTestId}${expanded ? 'Expanded' : 'Collapsed'}`}>
      <div className={styles.cardHeaderText}>{content}</div>
      <div className={styles.expandArrow}>{expandableArrow}</div>
    </div>
  )
}
